import React, { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Button } from "antd"; // Using Ant Design Input for better UI consistency
import Select from "react-select";
import { Delete, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "../../../../Components/UI/Input";
import dayjs from "dayjs";
const Inventory = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const inventoryDetails = watch("inventoryDetails") || [];

  const addInventoryRow = () => {
    const newInventory = {
      companyCode: watch("companyCode"),
      code: 0,
      employeeCode: watch("employeeCode"),
      itemName: "",
      quantity: "",
      dateOfIssue: "",
      dateOfCollection: "",
      description: "",
      isActive: true,
      image: "",
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
    };


    setValue("inventoryDetails", [...inventoryDetails, newInventory]);
  };

  const removeInventory = (index) => {
    const updatedInventory = inventoryDetails.filter((_, i) => i !== index);
    setValue("inventoryDetails", updatedInventory);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      > <h4></h4>
        <button className="btn btn-secondary btn-sm" type="button" onClick={addInventoryRow}>
          Add Row
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Item Name</th>
              <th>Quantity</th>
              <th>Description</th>
              <th>Date Of Issue</th>
              <th>Date Of Collection</th>
            </tr>
          </thead>
          <tbody>
            {inventoryDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button
                      type="danger"
                      onClick={() => removeInventory(index)}
                    >
                      <Trash2 />
                    </Button>
                  </td>
                  <td>
                    <Input
                      name={`inventoryDetails[${index}].itemName`}
                      type="text"
                      placeholder="Item Name"
                      className={`form-control ${
                        errors?.inventoryDetails?.[index]?.itemName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                    />
                  </td>
                  <td>
                    <Input
                      name={`inventoryDetails[${index}].quantity`}
                      type="text"
                      placeholder="Quantity"
                      className={`form-control ${
                        errors?.inventoryDetails?.[index]?.quantity
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                    />
                  </td>

                  <td>
                    <Input
                      name={`inventoryDetails[${index}].description`}
                      type="text"
                      placeholder="Description"
                      className={`form-control ${
                        errors?.inventoryDetails?.[index]?.description
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                    />
                  </td>

                  <td>
                    <Input
                      name={`inventoryDetails[${index}].dateOfIssue`}
                      type="date"
                      placeholder="Date of Issue"
                      className={`form-control ${
                        errors?.inventoryDetails?.[index]?.dateOfIssue
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`workExperienceDetails[${index}].weFromdate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                    />
                  </td>
                  <td>
                    <Input
                      name={`inventoryDetails[${index}].dateOfCollection`}
                      type="date"
                      placeholder="Date of Collection"
                      className={`form-control ${
                        errors?.inventoryDetails?.[index]?.dateOfCollection
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(
                            `workExperienceDetails[${index}].dateOfCollection`
                          ),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Inventory;
